import moment from 'moment'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Card from '@/components/Card'
import PaginationTable from '@/components/PaginationTable'

import columns from './columns'
import messages from './messages'

import './index.scss'

import { isEmpty } from 'lodash'

import { Refresh } from '@/components/Icons'
import ImagePreview from '@/components/ImagePreview'

import ConnectorLogFilters from './ConnectorLogFilters'

const ConnectorLogView = (props: any) => {
  const { offset, totalResults, perPage, logs, searchParams, searchLogs, currentConnector, isActionInProgress } = props
  const [sortingColumns] = useState(null)
  const [message] = useState(<FormattedMessage {...messages.fetchingLogs} />)

  const onSelect = (page: any) => {
    const offset = (page - 1) * perPage
    searchLogs({ ...searchParams, offset })
  }

  const refreshLogs = (searchParams: any) => {
    searchLogs({ ...searchParams, offset: 0, end: moment(new Date()).toISOString() })
  }
  const searchConnectorLogs = (searchParams: any) => {
    searchLogs(searchParams)
  }

  const buildTitle = () => {
    return isEmpty(currentConnector) ? null : (
      <div className="connector-logs-title">
        <div>
          <ImagePreview
            id="source-image-preview"
            className="icon-preview-image"
            imageUrl={currentConnector.overrideAppIconUrl || currentConnector.iconUrl}
            title={currentConnector.overrideAppName || currentConnector.name}
          />
        </div>
        <div className="connector-title">
          {currentConnector.name && (
            <FormattedMessage
              {...messages.logs}
              values={{
                connectorName: currentConnector.overrideAppName || currentConnector.name
              }}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <Card isActionInProgress={isActionInProgress} actionMessage={message}>
      <Card.Header title={buildTitle()}>
        <div className="connector-logs-options">
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className="connector-logs-options-item"
            onClick={() => {
              refreshLogs(searchParams)
            }}
          >
            <Refresh className="options-icon" />
            <FormattedMessage {...messages.refreshButton} />
          </div>
        </div>
      </Card.Header>
      <Card.Content>
        <div className="connector-logs-view-wrapper">
          <ConnectorLogFilters searchParams={searchParams} searchLogs={searchConnectorLogs} />
          {logs?.length > 0 ? (
            <PaginationTable
              columns={columns()}
              pagination={{
                count: totalResults,
                startIndex: offset + 1,
                perPage: perPage
              }}
              onPaginateSelect={onSelect}
              rows={logs}
              rowItemType={<FormattedMessage {...messages.connectorLogs} />}
              rowKey="_index"
              sortingColumn={sortingColumns}
            />
          ) : (
            <p className="no-users flex-center">
              <FormattedMessage {...messages.noLogs} />
            </p>
          )}
        </div>
      </Card.Content>
    </Card>
  )
}

ConnectorLogView.propTypes = {
  isActionInProgress: PropTypes.bool,
  offset: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  logs: PropTypes.arrayOf(PropTypes.object).isRequired,
  searchParams: PropTypes.object.isRequired,
  searchLogs: PropTypes.func.isRequired,

  currentConnector: PropTypes.object.isRequired
}

ConnectorLogView.defaultProps = {
  isSearching: false,
  isActionInProgress: false
}
export default ConnectorLogView
